module.exports = __webpack_public_path__ + "static/media/arrow-right-black.7fd6a457.svg";